import React from 'react';
import ComingSoon from './ComingSoon';

const ProfileShare = () => {
  return <ComingSoon pageName="Share App" />;
};

export default ProfileShare;
